<template>
  <div v-if="categoryIsLoad" class="comp-main">
    <div :class="{ 'comp-top': true, disabled }" :title="promptStr" @click="toggleCategoryTexture">
      <span>{{ activeStr }}</span>
      <el-link v-if="!disabled" class="m-l-5" type="primary">
        {{ isShowCategoryTexture ? '收起↑' : '展开↓' }}
      </el-link>
    </div>
    <div v-show="isShowCategoryTexture" class="comp-cont">
      <b-goods-category
        :ids="categoryRouteIds"
        :isInit="!categoryRouteIds.length"
        @success="getCategoryActiveList"
      />
      <div style="margin-left: -1px">
        <b-goods-texture :categoryId="categoryLastId" :data.sync="textureActiveObj" />
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    data: {
      type: Object,
      required: true
    },
    disabled: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      isShowCategoryTexture: false,
      categoryIsLoad: false,
      categoryLastId: '',
      categoryRouteIds: [],
      categoryActiveList: [],
      textureActiveObj: {}
    }
  },
  computed: {
    // 类目选中末级
    categoryActiveObj() {
      let result = ''
      let len = this.categoryActiveList.length
      if (len) result = this.categoryActiveList[len - 1]
      return result
    },
    // 类目材质选中字符串
    activeStr() {
      let result = ''
      let listName = this.categoryActiveList.map((item) => item.name) // 类目
      if (this.textureActiveObj.key) listName.push(this.textureActiveObj.key) // 材质
      result = listName.join(' / ')
      return result // 类目材质拼接成字符串
    },
    // 切换字符串
    toggleStr() {
      let result = this.isShowCategoryTexture ? '收起↑' : '展开↓'
      return result
    },
    // 提示字符串
    promptStr() {
      let result = this.activeStr
      if (!this.disabled) result = `${result}（点击${this.toggleStr}）`
      return result
    },
    // 类目材质选中数据
    categoryTextureActiveData() {
      let result = {
        categoryList: this.$util.deepCopy(this.categoryActiveList),
        textureData: this.$util.deepCopy(this.textureActiveObj)
      }
      return result
    }
  },
  watch: {
    categoryActiveObj(newVal, oldVal) {
      if (newVal.id !== oldVal.id) {
        if (newVal.has_children) {
          this.categoryLastId = ''
        } else {
          this.categoryLastId = newVal.id
        }
      }
    },
    categoryTextureActiveData: {
      handler(val) {
        this.$emit('update:data', this.$util.deepCopy(val))
      },
      deep: true
    }
  },
  mounted() {
    this.getCategoryRouteIds()
  },
  methods: {
    toggleCategoryTexture() {
      if (!this.disabled) this.isShowCategoryTexture = !this.isShowCategoryTexture
    },
    // 获取路由类目ids
    getCategoryRouteIds() {
      this.categoryIsLoad = false
      let idsStr = this.$route.query.ids
      let idsList = []
      if (idsStr) idsList = idsStr.split(',')
      this.categoryRouteIds = idsList.map((item) => Number(item))
      this.categoryIsLoad = true
    },
    // 获取选中类目列表
    getCategoryActiveList(list) {
      this.categoryActiveList = []
      list.forEach((itemSt) => {
        itemSt.category.forEach((itemNd) => {
          if (itemSt.title.active_id === itemNd.id) {
            this.categoryActiveList.push(this.$util.deepCopy(itemNd))
          }
        })
      })
    }
  }
}
</script>

<style lang="less" scoped>
.comp-main {
  position: relative;
  .comp-top {
    display: flex;
    align-items: center;
    justify-content: space-between;
    width: 100%;
    height: 26px;
    padding: 0 5px;
    border: 1px solid #ddd;
    border-radius: 2px;
    box-sizing: border-box;
    cursor: pointer;
    &.disabled {
      background: @colorGrayF;
      cursor: not-allowed;
    }
  }
  .comp-cont {
    position: absolute;
    top: 33px;
    left: 0;
    display: flex;
  }
}
</style>
